const config = {
  crownColors: [
    '#9CB7F3',
    '#fff',
    '#FEDD03',
    '#F1A891',
    '#9AD09D'
  ],
  getCrownColor (slipyear) {
    return config.crownColors[slipyear % config.crownColors.length]
  },
  cachedFunction (fn) {
    let cache = {}
    let time = {}

    const cachedFn = async function () {
      if (!config.cacheEnabled) {
        return fn.apply(null, arguments)
      }

      const key = JSON.stringify(arguments)

      if (!time[key] || Date.now() - time[key] > config.cacheTTL) {
        time[key] = Date.now()
        cache[key] = await fn.apply(null, arguments)
        return cache[key]
      } else {
        return cache[key]
      }
    }

    cachedFn.invalidate = function () {
      time = {}
    }

    return cachedFn
  },
  cacheTTL: 5 * 60 * 1000, // 5 min
  cacheEnabled: true,
  // cacheEnabled: false,
  // serverUrl: 'http://imkerportal.local' // Local
  serverUrl: 'https://imker-portal.die-etagen.de' // Stage
  // serverUrl: 'https://dib-imker-app.de' // Live
}

export default config
